
export const HIGHLIGHT_COLORS = [
  { name: 'Yellow', value: '#fff9c4', label: 'General emphasis' },
  { name: 'Blue', value: '#cce5ff', label: 'Informational notes' },
  { name: 'Green', value: '#d0f0c0', label: 'Success/positive remarks' },
  { name: 'Red', value: '#f8d7da', label: 'Warnings or errors' },
  { name: 'Purple', value: '#e0d6f5', label: 'Creative/editorial notes' },
  { name: 'Orange', value: '#ffe0b2', label: 'Caution/upcoming items' },
];
